import thumb from '../../../assets/images/textify/thumb.png';
import full01 from '../../../assets/images/textify/full01.png';
import full02 from '../../../assets/images/textify/full02.png';
import full03 from '../../../assets/images/textify/full03.png';
import full04 from '../../../assets/images/textify/full04.png';
import full05 from '../../../assets/images/textify/full05.png';
import full06 from '../../../assets/images/textify/full06.png';
import full07 from '../../../assets/images/textify/full07.png';

const textifyData = {
  name: 'Textify',
  description:
    'Free online OCR service for converting images, photos and screenshots to text.',
  skills: ['Bootstrap4', 'SCSS', 'Gatsby'],
  sources: [
    { caption: 'Home | Textify', source: full01 },
    { caption: 'Image Conversion Process', source: full02 },
    { caption: 'All Queries | Textify', source: full03 },
    { caption: 'Edit Query | Textify', source: full04 },
    { caption: 'Image Conversion Process', source: full05 },
    { caption: 'All Queries | Textify', source: full06 },
    { caption: 'Edit Query | Textify', source: full07 },
  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/textify',
  liveUrl: 'https://textify-image.netlify.app/',
};

export default textifyData;
